import { useEffect, useState } from "react";
import userManager from "../features/authorization/authService";

import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
  loadInitialAuthenticationStateAsync,
  selectAuthInitializationStatus,
} from "../features/authentication/authenticationSlice";
import { ROUTES } from "../routes";
import { StringExtension } from "../features/extensions/StringExtension";
import { resolvePathAfterSignIn } from "../features/contexts/utils/postSignIn";

const AuthorizeRedirectPage = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const initializationStatus = useAppSelector(selectAuthInitializationStatus);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isCallback = urlParams.has("code") || urlParams.has("state");

    if (isCallback) {
      userManager
        .signinRedirectCallback()
        // The OIDC user is in the store before the post-sign-in lookup sends its token.
        .then(() => dispatch(loadInitialAuthenticationStateAsync()))
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [navigate, dispatch]);

  useEffect(() => {
    if (loading === false) {
      const stringExtension = new StringExtension();
      let redirectUrl = localStorage.getItem("redirectUrl") || ROUTES.HOME;
      // Used once: a stale redirect from an earlier logout must not skip the chooser on every later sign-in.
      localStorage.removeItem("redirectUrl");
      if (stringExtension.isEquals(redirectUrl, ROUTES.LOGIN)) {
        redirectUrl = ROUTES.HOME;
      }
      // A pending invitation first, then the stored redirect, then the chooser for several contexts.
      resolvePathAfterSignIn(dispatch, redirectUrl).then((path) => navigate(path));
    }
  }, [loading, navigate, dispatch]);

  if (initializationStatus === "not-initialized" || loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <svg className="animate-spin h-10 w-10 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-screen">
      <span className="text-xl font-semibold">You successfully authorized</span>
    </div>
  );
};

export default AuthorizeRedirectPage;
